// Store
import { useProductData } from "@/zustand/productStore";
import { useTemplateStore } from "@/zustand/templateStore";

// Components
import ProductCards from "@/components/Cards/ProductCards";
import Skeleton from "@/components/Skeleton";
import Box from "@/components/Box";

export default function ProductList() {
  const { productList, settings } = useTemplateStore();
  const productData = useProductData();

  return (
    <Box
      className={`shadow-cc gap-4 p-3 md:p-4 ${
        !productList?.rounded_borders ? "rounded-none" : ""
      }`}
    >
      <span
        className={`text-xl font-bold ${
          settings.enable_high_contrast ? "text-cc-dark-gray" : "text-cc-gray"
        }`}
      >
        {productList?.tr_title}
      </span>

      {productData?.products ? (
        <ProductCards products={productData?.products || []} />
      ) : (
        <Skeleton />
      )}
    </Box>
  );
}
